export default "__VITE_ASSET__W_mNhP2M__"